<template>
   <div class="layout">
      <NuxtPage />
   </div>
</template>
<script setup lang="ts">
// const { teachable } = useTeachable();
</script>
